module.exports = __webpack_public_path__ + "static/media/flag-european-union.a03ec537.svg";